import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { FLEET_ID_QUERY_PARAM_KEY } from '../../constants';

/**
 * Adds fleet_id to a path if present in current URL.
 * Reads from window.location because fleet_id is set via replaceState.
 */
export const preserveFleetId = (path: string): string => {
  const fleetId = new URLSearchParams(window.location.search).get(FLEET_ID_QUERY_PARAM_KEY);
  if (!fleetId) {
    return path;
  }

  const [basePath, existingSearch] = path.split('?');
  const params = new URLSearchParams(existingSearch || '');

  if (!params.has(FLEET_ID_QUERY_PARAM_KEY)) {
    params.set(FLEET_ID_QUERY_PARAM_KEY, fleetId);
  }

  return `${basePath}?${params.toString()}`;
};

/**
 * Link that preserves fleet_id query parameter when navigating.
 */
export const QueryPreservingLink: React.FC<LinkProps> = ({ to, children, ...props }) => {
  const preservedTo = typeof to === 'string' ? preserveFleetId(to) : to;

  return (
    <Link to={preservedTo} {...props}>
      {children}
    </Link>
  );
};
